import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, Star } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-cream-50" data-id="element-106">
      {/* Top Bar */}
      <div className="bg-wine-900 text-cream-50 py-2 text-center text-sm font-medium tracking-wide" data-id="element-107">
        PROFE LISTO · DANZA INFANTIL 360
      </div>

      <div className="max-w-4xl mx-auto px-4 min-h-[calc(100svh-2.5rem)] sm:min-h-0 flex flex-col justify-center py-5 sm:pt-16 sm:pb-24" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-109">
          {/* Headline */}
          <h1 className="font-serif text-2xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-3 sm:mb-8" data-id="element-110">
            Todo tu año de danza infantil <br className="hidden sm:block" data-id="element-111" />
            <span className="text-wine-700 relative inline-block" data-id="element-112">
              resuelto de una vez.
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold-400/60" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-113">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-114" />
              </svg>
            </span>
          </h1>

          {/* Main Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full max-w-[180px] sm:max-w-xl mb-4 sm:mb-10" data-id="element-115">
            <img src="https://cdn.magicpatterns.com/uploads/j6xyAQ5zrJ5HWuVvKPJo6z/395.png" alt="Megapack DANZA INFANTIL 360 — colección completa de tomos, bonus y recursos para profesoras de danza infantil" className="w-full h-auto drop-shadow-2xl" width={1080} height={1350} loading="eager" fetchpriority="high" decoding="async" data-id="element-116" />
          </motion.div>

          {/* Subtitle */}
          <p className="text-base sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3" data-id="element-117">
            Megapack DANZA INFANTIL 360 — Pack Anual Elite Completo
          </p>

          {/* Supporting Subhead */}
          <p className="text-sm sm:text-lg text-gray-700 mb-4 sm:mb-8 max-w-2xl" data-id="element-118">
            El sistema completo de planificaciones y secuencias para la
            profesora de danza infantil argentina
          </p>

          {/* Format Badges */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-5 sm:mb-10" data-id="element-119">
            <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-1.5 rounded-full bg-cream-200 text-wine-900 text-xs sm:text-sm font-bold shadow-sm" data-id="element-120">
              📄 PDF
            </span>
            <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-1.5 rounded-full bg-cream-200 text-wine-900 text-xs sm:text-sm font-bold shadow-sm" data-id="element-121">
              ⚡ Acceso Inmediato
            </span>
            <span className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-1.5 rounded-full bg-gold-100 text-gold-900 border border-gold-200 text-xs sm:text-sm font-bold shadow-sm" data-id="element-122">
              📚 12 Tomos + 6 Bonus + 2 Elite
            </span>
          </div>

          {/* Primary CTA */}
          <div className="w-full max-w-md space-y-4 sm:space-y-5 mb-8 sm:mb-12" data-id="element-123">
            <Button href="#precio" variant="primary" size="lg" className="w-full sm:text-xl md:text-2xl animate-pulse-slow shadow-wine-700/30" data-id="element-124">
              💃 QUIERO MI DANZA INFANTIL 360 AHORA
            </Button>

            {/* Guarantee / Secure Microcopy */}
            <div className="flex flex-wrap justify-center items-center gap-4 text-sm text-gray-600 font-medium" data-id="element-125">
              <span className="flex items-center gap-1" data-id="element-126">
                <Shield className="w-4 h-4 text-gold-500" data-id="element-127" /> 🛡️ Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-128">
                <Lock className="w-4 h-4 text-gold-500" data-id="element-129" /> 🔒 Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-130">
                <CreditCard className="w-4 h-4 text-gold-500" data-id="element-131" /> 💳 Tarjetas y
                transferencia
              </span>
            </div>
          </div>

          {/* Social Proof Line */}
          <div className="pt-6 border-t border-cream-200 flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-gray-700" data-id="element-132">
            <div className="flex items-center gap-2" data-id="element-133">
              <div className="flex -space-x-2" data-id="element-134">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-cream-200 border-2 border-white flex items-center justify-center text-xs font-bold text-wine-800" data-id="element-135">
                    {String.fromCharCode(64 + i)}
                  </div>)}
              </div>
              <span className="font-bold" data-id="element-136">+300 profes confían</span>
            </div>
            <span className="hidden sm:inline text-gray-300" data-id="element-137">|</span>
            <span className="font-medium" data-id="element-138">12+6 Tomos + Bonus</span>
            <span className="hidden sm:inline text-gray-300" data-id="element-139">|</span>
            <span className="flex items-center gap-1 font-bold" data-id="element-140">
              4.9/5 calificación{' '}
              <Star className="w-4 h-4 text-gold-500 fill-gold-500 inline" data-id="element-141" />
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-142">|</span>
            <span className="font-medium" data-id="element-143">🇦🇷 Argentina · MP</span>
          </div>
        </motion.div>
      </div>

      {/* Intro Testimonials */}
      <div className="bg-white py-12 border-y border-cream-200" data-id="element-144">
        <div className="max-w-6xl mx-auto px-4" data-id="element-145">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-146">
            <TestimonialCard quote='"Organicé todo el trimestre en una tarde. Nunca más llego a clase sin saber qué ejercicio dar ni para qué sirve."' author="Laura M., Buenos Aires" role="Profesora de Danza Infantil en Estudio Propio" data-id="element-147" />
            <TestimonialCard quote='"Mis alumnos de Nivel Inicial de 3 años mejoraron su control motor desde la primera semana con el Tomo 1."' author="Gabriela S., Córdoba" role="Profesora de Danza en Academia Privada" data-id="element-148" />
            <TestimonialCard quote='"Antes tardaba 2 horas armando una clase. Ahora son 5 minutos. Mis domingos volvieron a ser míos."' author="Rocío F., Rosario" role="Profesora de Danza Independiente" data-id="element-149" />
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  quote,
  author,
  role
}: {
  quote: string;
  author: string;
  role: string;
}) {
  return <div className="bg-cream-50/50 p-6 rounded-2xl border border-cream-100 relative" data-id="element-150">
      <div className="flex gap-1 mb-4" data-id="element-151">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-152" />)}
      </div>
      <p className="font-handwriting text-2xl text-gray-800 mb-4 leading-snug" data-id="element-153">
        {quote}
      </p>
      <div data-id="element-154">
        <p className="font-bold text-wine-900 text-sm" data-id="element-155">{author}</p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-156">{role}</p>
      </div>
    </div>;
}